import { Helmet } from 'react-helmet-async';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_thriveit-preview/artifacts/xidnz9yy_PNG-02%20%282%29.png';

export const SEOHead = ({ title, description, canonical, schema, ogTitle, ogDescription, ogImage, ogType }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:type" content={ogType || 'website'} />
      <meta property="og:site_name" content="Thriveit Media" />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:image" content={ogImage || LOGO_URL} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || title} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage || LOGO_URL} />
      {schema && !Array.isArray(schema) && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
      {schema && Array.isArray(schema) && schema.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};
